const galleryModal = document.querySelector(".slider_gallery__popup");

document.querySelectorAll(".product__modal-custom-opener .product__media")?.forEach((container) => {
    const img = container.querySelector("img");

    container.addEventListener("mousemove", (e) => {
        const { left, top, width, height } = container.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = "scale(2)";
    });

    container.addEventListener("mouseleave", () => {
        img.style.transformOrigin = "center center";
        img.style.transform = "scale(1)";
    });
});

if (galleryModal){
    document.querySelectorAll(".product__modal-custom-opener")?.forEach((opener) => {
        opener.addEventListener("click", () => {
            galleryModal.classList.add("open");
        });
    });

    galleryModal.querySelector(".close-gallery-button")?.addEventListener("click", () => {
        galleryModal.classList.remove("open");
    });
}
